<template>
    <el-dialog
      title="提示"
      :visible.sync="notPassDialogShow"
      width="30%"
      top="20vh"
      append-to-body
      :before-close="handleNotPassClose">
        <el-form ref="formRef" :model="form" label-width="85px" :rules="rules">
          <el-form-item label="原因" prop="verifiedRecord">
            <el-input type="textarea" v-model="form.verifiedRecord" placeholder="原因"></el-input>
          </el-form-item>
          <div class="quick_item">
            <el-dropdown trigger="click" size="small" @command="handleQuickChange">
              <span class="el-dropdown-link hand">
                快捷回复<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item style="max-width: 465px;" :divided="index !==0"
                                  v-for="(item, index) in quickList" :key="index"
                                  :command="item">{{item}}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" size="mini" plain @click="handleNotPassClose">取消</el-button>
          <el-button type="primary" size="mini" @click="handleSubmit">提交</el-button>
        </span>
    </el-dialog>
</template>

<script>
export default {
  components: {
  },
  props: {
    notPassDialogShow: {
      type: Boolean
    },
    fwId: {
      type: Number
    },
    name: {
      type: String,
      default: '9'
    },
    verified: {
      type: Number
    }
  },
  data () {
    return {
      isAllFinish: false,
      userFwInfo: {},
      form: {
        verifiedRecord: ''
      },
      rules: {
        verifiedRecord: [
          { required: true, message: '请输入原因', trigger: 'blur' }
        ]
      },
      notPassDialog: false,
      quickList: ['专家驳回', '审核不通过'],
      allLength: 0
    }
  },
  methods: {
    handleNotPassClose () {
      this.$emit('update:notPassDialogShow', false)
      this.form.verifiedRecord = ''
    },
    handleQuickChange (value) {
      this.form.verifiedRecord = value
    },
    handleSubmit (verify) {
      this.$refs.formRef.validate(async (valid) => {
        if (valid) {
          this.$emit('handleExamine', this.verified, this.form.verifiedRecord)
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.quick_item {
  text-align: end;
}
</style>
